module.exports = __webpack_public_path__ + "static/media/Nina.2a34c097.jpg";